/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Initialize filter popover on mobile (bottom sheet style, matching sort behavior)
 */
(function() {
  'use strict';

  var filterPopoverInstance = null;

  // Check if we're on mobile (using the same breakpoint as the theme)
  function isMobile() {
    return window.matchMedia('(max-width: 640px)').matches;
  }

  function initFilterPopover() {
    var filterPopoverElement = document.getElementById('collection-filter-popover');
    var filterButton = document.querySelector('[data-filter-button]');
    
    if (!filterPopoverElement) {
      console.log('Filter popover: Element not found');
      return;
    }
    
    if (!filterButton) {
      console.log('Filter popover: Button not found');
      return;
    }
    
    console.log('Filter popover: Initialized', { element: filterPopoverElement, button: filterButton, isMobile: isMobile() });

    // Remove drawer attributes on mobile to prevent drawer from opening
    if (isMobile()) {
      filterButton.removeAttribute('data-action');
      filterButton.removeAttribute('data-drawer-id');
    }

    // Function to hide the Filters button
    function hideFiltersButton() {
      // Find the collapsible that contains the Linklist (filter options)
      var valueList = filterPopoverElement.querySelector('.Popover__ValueList');
      if (!valueList) return;
      
      // Find all collapsibles
      var collapsibles = valueList.querySelectorAll('.Collapsible');
      
      collapsibles.forEach(function(collapsible) {
        var linklist = collapsible.querySelector('.Linklist');
        if (linklist) {
          // This is the Filters wrapper - hide its button
          collapsible.setAttribute('data-hide-button', 'true');
          
          var button = collapsible.querySelector('.Collapsible__Button');
          if (button) {
            // Completely hide and disable
            button.style.cssText = 'display: none !important; visibility: hidden !important; height: 0 !important; padding: 0 !important; margin: 0 !important; opacity: 0 !important; pointer-events: none !important; position: absolute !important; left: -9999px !important; width: 0 !important;';
            button.setAttribute('aria-hidden', 'true');
            button.setAttribute('tabindex', '-1');
            button.setAttribute('disabled', 'true');
            
            // Remove all event listeners by replacing with a disabled button
            var parent = button.parentNode;
            var newButton = document.createElement('button');
            newButton.className = button.className;
            newButton.style.cssText = button.style.cssText;
            newButton.setAttribute('aria-hidden', 'true');
            newButton.setAttribute('tabindex', '-1');
            newButton.setAttribute('disabled', 'true');
            newButton.setAttribute('type', 'button');
            parent.replaceChild(newButton, button);
            
            // Expand the inner content
            var inner = collapsible.querySelector('.Collapsible__Inner');
            if (inner) {
              inner.style.cssText = 'height: auto !important; visibility: visible !important; overflow: visible !important; display: block !important; max-height: none !important; margin-top: 0 !important; padding-top: 0 !important;';
              inner.setAttribute('aria-hidden', 'false');
            }
            
            collapsible.setAttribute('data-force-expanded', 'true');
          }
        }
      });
    }

    // Simple popover implementation for mobile
    function openPopover() {
      if (!isMobile()) return;
      filterPopoverElement.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('no-scroll');
      var pageOverlay = document.querySelector('.PageOverlay');
      if (pageOverlay) {
        pageOverlay.classList.add('is-visible');
        pageOverlay.addEventListener('click', closePopover);
      }
      filterButton.setAttribute('aria-expanded', 'true');
      
      // Hide the "Filters" button immediately
      hideFiltersButton();
      
      // Hide the "Filters" button (with plus icon) but keep the filter options visible
      // Auto-expand all collapsible sections in the filter popover
      setTimeout(function() {
        hideFiltersButton(); // Run again to be sure
        // Find all collapsibles in the popover
        var collapsibles = filterPopoverElement.querySelectorAll('.Popover__ValueList .Collapsible');
        
        collapsibles.forEach(function(collapsible) {
          var button = collapsible.querySelector('.Collapsible__Button');
          if (!button) return;
          
          // Check if this collapsible contains a Linklist (filter options)
          var hasLinklist = collapsible.querySelector('.Linklist');
          
          // Get button text
          var buttonText = button.textContent.trim();
          var plusIcon = button.querySelector('.Collapsible__Plus');
          if (plusIcon) {
            buttonText = buttonText.replace(plusIcon.textContent || '', '').trim();
          }
          
          // This is the "Filters" wrapper button if it has Linklist inside
          if (hasLinklist && (buttonText === 'Filters' || buttonText.toLowerCase().includes('filter'))) {
            // Completely remove the button from DOM or hide it thoroughly
            button.style.cssText = 'display: none !important; visibility: hidden !important; height: 0 !important; padding: 0 !important; margin: 0 !important; opacity: 0 !important; pointer-events: none !important; position: absolute !important; left: -9999px !important;';
            button.setAttribute('aria-hidden', 'true');
            button.setAttribute('tabindex', '-1');
            
            // Remove all event listeners by cloning
            var newButton = button.cloneNode(true);
            button.parentNode.replaceChild(newButton, button);
            button = newButton;
            
            // Prevent any clicks
            button.addEventListener('click', function(e) {
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();
              return false;
            }, true);
            
            // Make sure the inner content is always visible and expanded
            var inner = collapsible.querySelector('.Collapsible__Inner');
            if (inner) {
              inner.style.cssText = 'height: auto !important; visibility: visible !important; overflow: visible !important; display: block !important; max-height: none !important; margin-top: 0 !important; padding-top: 0 !important;';
              inner.setAttribute('aria-hidden', 'false');
              
              var content = inner.querySelector('.Collapsible__Content');
              if (content) {
                content.style.display = 'block';
              }
            }
            
            // Set attributes
            collapsible.setAttribute('data-force-expanded', 'true');
            button.setAttribute('aria-expanded', 'true');
          } else {
            // For other collapsibles (like quick links, groups), just expand them
            button.setAttribute('aria-expanded', 'true');
            
            var inner = collapsible.querySelector('.Collapsible__Inner');
            if (inner) {
              inner.style.height = 'auto';
              inner.style.visibility = 'visible';
              inner.style.overflow = 'visible';
            }
          }
        });
      }, 100);
    }

    function closePopover() {
      filterPopoverElement.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('no-scroll');
      var pageOverlay = document.querySelector('.PageOverlay');
      if (pageOverlay) {
        pageOverlay.classList.remove('is-visible');
        pageOverlay.removeEventListener('click', closePopover);
      }
      filterButton.setAttribute('aria-expanded', 'false');
    }

    function togglePopover() {
      var isOpen = filterPopoverElement.getAttribute('aria-hidden') === 'false';
      if (isOpen) {
        closePopover();
      } else {
        openPopover();
      }
    }

    // Override the filter button click to open popover on mobile instead of drawer
    // Use capture phase to intercept before drawer handler
    filterButton.addEventListener('click', function(e) {
      if (isMobile()) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        togglePopover();
        return false;
      }
      // On desktop, let the default drawer behavior work
    }, true); // Use capture phase

    // Handle close button in popover
    var closeButton = filterPopoverElement.querySelector('[data-action="close-popover"]');
    if (closeButton) {
      closeButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        closePopover();
      });
    }

    // Handle apply tags button in popover
    filterPopoverElement.addEventListener('click', function(e) {
      if (e.target.closest('[data-action="apply-tags"]')) {
        // Let the default handler work, then close popover
        setTimeout(function() {
          closePopover();
        }, 100);
      }
    });

    // Close on overlay click
    var pageOverlay = document.querySelector('.PageOverlay');
    if (pageOverlay) {
      var overlayClickHandler = function() {
        if (isMobile() && filterPopoverElement.getAttribute('aria-hidden') === 'false') {
          closePopover();
        }
      };
      pageOverlay.addEventListener('click', overlayClickHandler);
    }

    filterPopoverInstance = {
      open: openPopover,
      close: closePopover,
      toggle: togglePopover
    };
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFilterPopover);
  } else {
    initFilterPopover();
  }

  // Re-initialize on section load (for AJAX navigation)
  document.addEventListener('shopify:section:load', function() {
    setTimeout(initFilterPopover, 100);
  });

  // Fix button text disappearing after filter/sort is applied
  function ensureFilterButtonText() {
    var filterButtons = document.querySelectorAll('[data-filter-button]');
    filterButtons.forEach(function(filterButton) {
      var span = filterButton.querySelector('span');
      if (!span || span.textContent.trim() === '' || span.textContent.trim().length < 3) {
        // Restore the text if it's missing or too short
        var icon = filterButton.querySelector('svg');
        var tagCount = 0;
        try {
          var tagCountElement = span ? span.querySelector('.Text--subdued') : null;
          if (tagCountElement) {
            var match = tagCountElement.textContent.match(/\((\d+)\)/);
            if (match) tagCount = parseInt(match[1], 10);
          }
        } catch(e) {}
        
        var filterText = 'Filter';
        if (tagCount > 0) {
          filterText += ' <span class="Text--subdued">(' + tagCount + ')</span>';
        }
        
        if (span) {
          span.innerHTML = filterText;
        } else {
          var newSpan = document.createElement('span');
          newSpan.innerHTML = filterText;
          if (icon && icon.nextSibling) {
            filterButton.insertBefore(newSpan, icon.nextSibling);
          } else if (icon) {
            filterButton.appendChild(newSpan);
          }
        }
      }
    });
  }

  // Run after page loads and after AJAX updates
  function runButtonTextFix() {
    setTimeout(ensureFilterButtonText, 100);
    setTimeout(ensureFilterButtonText, 500);
    setTimeout(ensureFilterButtonText, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runButtonTextFix);
  } else {
    runButtonTextFix();
  }

  // Also run after collection updates (when filters/sort are applied)
  document.addEventListener('shopify:section:load', runButtonTextFix);
  
  // Listen for collection reload events
  document.addEventListener('theme:loading:end', runButtonTextFix);

  // Also intercept at document level to catch it before drawer handler
  document.addEventListener('click', function(e) {
    var filterButton = e.target.closest('[data-filter-button]');
    if (filterButton && isMobile()) {
      var filterPopoverElement = document.getElementById('collection-filter-popover');
      if (filterPopoverElement) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        var isOpen = filterPopoverElement.getAttribute('aria-hidden') === 'false';
        if (isOpen) {
          filterPopoverElement.setAttribute('aria-hidden', 'true');
          document.documentElement.classList.remove('no-scroll');
          var pageOverlay = document.querySelector('.PageOverlay');
          if (pageOverlay) {
            pageOverlay.classList.remove('is-visible');
          }
          filterButton.setAttribute('aria-expanded', 'false');
        } else {
          filterPopoverElement.setAttribute('aria-hidden', 'false');
          document.documentElement.classList.add('no-scroll');
          var pageOverlay = document.querySelector('.PageOverlay');
          if (pageOverlay) {
            pageOverlay.classList.add('is-visible');
          }
          filterButton.setAttribute('aria-expanded', 'true');
        }
        return false;
      }
    }
  }, true); // Use capture phase to intercept early
})();

/**
 * Progressive disclosure for product gallery thumbnails
 * Shows 3-4 thumbnails at a time with up/down arrow navigation
 */
(function() {
  'use strict';

  function initThumbnailProgressiveDisclosure() {
    var thumbnailNav = document.querySelector('.Product__SlideshowNav--thumbnails');
    if (!thumbnailNav) return;

    var scroller = thumbnailNav.querySelector('.Product__SlideshowNavScroller');
    if (!scroller) return;

    var upArrow = thumbnailNav.querySelector('.Product__ThumbnailNavArrow--up');
    var downArrow = thumbnailNav.querySelector('.Product__ThumbnailNavArrow--down');
    var thumbnails = Array.from(thumbnailNav.querySelectorAll('.Product__SlideshowNavImage'));

    if (thumbnails.length <= 4) {
      // Not enough thumbnails to need scrolling - hide arrows
      if (upArrow) upArrow.style.display = 'none';
      if (downArrow) downArrow.style.display = 'none';
      return;
    }
    
    // Ensure arrows are displayable (they start hidden via CSS)
    if (upArrow) upArrow.style.display = 'flex';
    if (downArrow) downArrow.style.display = 'flex';

    // Calculate thumbnail height including margin
    function getThumbnailHeight() {
      if (thumbnails.length === 0) return 0;
      var firstThumb = thumbnails[0];
      var rect = firstThumb.getBoundingClientRect();
      var style = window.getComputedStyle(firstThumb);
      var marginBottom = parseInt(style.marginBottom, 10) || 0;
      return rect.height + marginBottom;
    }

    // Update arrow state - keep visible but disable when at limits
    function updateArrowVisibility() {
      var scrollTop = scroller.scrollTop;
      var scrollHeight = scroller.scrollHeight;
      var clientHeight = scroller.clientHeight;
      var isAtTop = scrollTop <= 5; // Small threshold for rounding
      var isAtBottom = scrollTop + clientHeight >= scrollHeight - 5;

      if (upArrow) {
        if (isAtTop) {
          upArrow.classList.add('is-disabled');
        } else {
          upArrow.classList.remove('is-disabled');
        }
      }

      if (downArrow) {
        if (isAtBottom) {
          downArrow.classList.add('is-disabled');
        } else {
          downArrow.classList.remove('is-disabled');
        }
      }
    }

    // Scroll by one thumbnail
    function scrollThumbnails(direction) {
      var thumbnailHeight = getThumbnailHeight();
      var currentScroll = scroller.scrollTop;
      var scrollAmount = thumbnailHeight;

      if (direction === 'up') {
        scroller.scrollTo({
          top: currentScroll - scrollAmount,
          behavior: 'smooth'
        });
      } else if (direction === 'down') {
        scroller.scrollTo({
          top: currentScroll + scrollAmount,
          behavior: 'smooth'
        });
      }
    }

    // Smooth scroll helper with easing (for luxury feel)
    var isScrolling = false;
    var scrollTimeout = null;
    
    function smoothScrollTo(scroller, targetPosition, duration) {
      if (isScrolling) return; // Prevent overlapping scrolls
      
      duration = duration || 400; // 400ms for smooth, polished feel
      var startPosition = scroller.scrollTop;
      var distance = targetPosition - startPosition;
      var startTime = null;
      
      // If distance is very small, skip animation
      if (Math.abs(distance) < 2) {
        scroller.scrollTop = targetPosition;
        return;
      }
      
      isScrolling = true;
      
      function easeInOutCubic(t) {
        // Smooth easing function for luxury feel
        return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      }
      
      function animation(currentTime) {
        if (startTime === null) startTime = currentTime;
        var timeElapsed = currentTime - startTime;
        var progress = Math.min(timeElapsed / duration, 1);
        var easedProgress = easeInOutCubic(progress);
        
        scroller.scrollTop = startPosition + (distance * easedProgress);
        
        if (progress < 1) {
          requestAnimationFrame(animation);
        } else {
          isScrolling = false;
        }
      }
      
      requestAnimationFrame(animation);
    }
    
    // Scroll to specific thumbnail - centers it in viewport (luxury e-commerce best practice)
    function scrollToThumbnail(thumbnail, center) {
      if (!thumbnail) return;
      
      // Debounce rapid calls
      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }
      
      scrollTimeout = setTimeout(function() {
        center = center !== false; // Default to true (center), unless explicitly false
        
        var scrollerRect = scroller.getBoundingClientRect();
        var thumbnailRect = thumbnail.getBoundingClientRect();
        
        // Check if thumbnail is partially or completely outside visible area
        var isPartiallyVisible = (
          thumbnailRect.top < scrollerRect.bottom &&
          thumbnailRect.bottom > scrollerRect.top
        );
        
        var isCompletelyVisible = (
          thumbnailRect.top >= scrollerRect.top &&
          thumbnailRect.bottom <= scrollerRect.bottom
        );
        
        // If thumbnail is completely visible and centered, no need to scroll
        if (isCompletelyVisible && center) {
          var thumbnailCenter = thumbnailRect.top + (thumbnailRect.height / 2);
          var scrollerCenter = scrollerRect.top + (scrollerRect.height / 2);
          var centerOffset = Math.abs(thumbnailCenter - scrollerCenter);
          
          // If already centered (within 8px tolerance for smoother feel), don't scroll
          if (centerOffset < 8) {
            return;
          }
        }
        
        // If thumbnail is partially or completely outside visible area, scroll to it
        if (!isPartiallyVisible || (center && !isCompletelyVisible)) {
          if (center) {
            // Center the thumbnail in the viewport with smooth animation
            var thumbnailOffset = thumbnail.offsetTop - scroller.offsetTop;
            var thumbnailHeight = thumbnailRect.height;
            var scrollerHeight = scrollerRect.height;
            var scrollPosition = thumbnailOffset - (scrollerHeight / 2) + (thumbnailHeight / 2);
            
            smoothScrollTo(scroller, Math.max(0, scrollPosition), 400);
          } else {
            // Just bring into view (original behavior)
            var thumbnailHeight = getThumbnailHeight();
            var thumbnailIndex = thumbnails.indexOf(thumbnail);
            var scrollPosition = thumbnailIndex * thumbnailHeight;
            
            smoothScrollTo(scroller, scrollPosition, 400);
          }
        }
      }, 50); // Small debounce to prevent jerky rapid scrolling
    }
    
    // Auto-scroll to selected thumbnail when main image changes (luxury e-commerce best practice)
    var autoScrollTimeout = null;
    function autoScrollToSelectedThumbnail() {
      // Debounce to prevent rapid-fire scrolling
      if (autoScrollTimeout) {
        clearTimeout(autoScrollTimeout);
      }
      
      autoScrollTimeout = setTimeout(function() {
        // Find the currently selected thumbnail
        var selectedThumbnail = thumbnails.find(function(thumb) {
          return thumb.classList.contains('is-selected');
        });
        
        if (selectedThumbnail && !isScrolling) {
          // Smoothly scroll to center the selected thumbnail
          scrollToThumbnail(selectedThumbnail, true);
        }
      }, 100); // Small delay to batch rapid changes
    }
    
    // Watch for changes to selected thumbnail (mutations or scroll events)
    function watchForImageChanges() {
      // For stack mode: Use Intersection Observer to detect when main images come into view
      var mainImages = document.querySelectorAll('.Product__SlideItem[data-media-id]');
      
      if (mainImages.length === 0) return;
      
      var visibleImages = new Map(); // Track intersection ratios for all visible images
      
      // Create Intersection Observer to detect when main images become visible
      var imageObserver = new IntersectionObserver(function(entries) {
        // Update visible images map
        entries.forEach(function(entry) {
          var mediaId = entry.target.getAttribute('data-media-id');
          
          if (entry.isIntersecting && entry.intersectionRatio > 0.1) {
            // Image is at least 10% visible
            visibleImages.set(mediaId, entry.intersectionRatio);
          } else {
            visibleImages.delete(mediaId);
          }
        });
        
        // Find the most visible image (highest intersection ratio)
        if (visibleImages.size > 0) {
          var mostVisibleMediaId = null;
          var maxRatio = 0;
          
          visibleImages.forEach(function(ratio, mediaId) {
            if (ratio > maxRatio) {
              maxRatio = ratio;
              mostVisibleMediaId = mediaId;
            }
          });
          
          // Only update if we have a clear winner (at least 30% visible)
          if (mostVisibleMediaId && maxRatio >= 0.3) {
            // Find corresponding thumbnail
            var correspondingThumbnail = thumbnails.find(function(thumb) {
              return thumb.getAttribute('data-media-id') === mostVisibleMediaId;
            });
            
            if (correspondingThumbnail) {
              var wasAlreadySelected = correspondingThumbnail.classList.contains('is-selected');
              
              // Remove selection from all thumbnails
              thumbnails.forEach(function(thumb) {
                thumb.classList.remove('is-selected');
              });
              
              // Add selection to corresponding thumbnail
              correspondingThumbnail.classList.add('is-selected');
              
              // Auto-scroll to center the selected thumbnail (only if it wasn't already selected)
              if (!wasAlreadySelected) {
                autoScrollToSelectedThumbnail();
              }
            }
          }
        }
      }, {
        threshold: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0], // Multiple thresholds for accurate tracking
        rootMargin: '-10% 0px -10% 0px' // Consider viewport with small margin
      });
      
      // Observe all main product images
      mainImages.forEach(function(image) {
        imageObserver.observe(image);
      });
      
      // Also watch for programmatic selection changes (DOM mutations) - for click events
      var thumbnailNav = document.querySelector('.Product__SlideshowNav--thumbnails');
      if (thumbnailNav) {
        var mutationObserver = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
              var target = mutation.target;
              // Check if any thumbnail was just selected
              if (target.classList.contains('is-selected') && thumbnails.includes(target)) {
                // Thumbnail was just selected (likely via click) - auto-scroll to center it
                autoScrollToSelectedThumbnail();
              }
            }
          });
        });
        
        mutationObserver.observe(thumbnailNav, {
          attributes: true,
          subtree: true,
          attributeFilter: ['class']
        });
      }
    }

    // Handle arrow clicks - only scroll if not disabled
    if (upArrow) {
      upArrow.addEventListener('click', function(e) {
        if (!upArrow.classList.contains('is-disabled')) {
          e.preventDefault();
          scrollThumbnails('up');
        }
      });
    }

    if (downArrow) {
      downArrow.addEventListener('click', function(e) {
        if (!downArrow.classList.contains('is-disabled')) {
          e.preventDefault();
          scrollThumbnails('down');
        }
      });
    }

    // Handle thumbnail clicks - auto-scroll if needed (center it)
    thumbnails.forEach(function(thumbnail) {
      thumbnail.addEventListener('click', function(e) {
        // Small delay to let the default click handler run first
        setTimeout(function() {
          scrollToThumbnail(thumbnail, true); // Center the clicked thumbnail
        }, 100);
      });
    });

    // Update arrow visibility on scroll
    scroller.addEventListener('scroll', function() {
      updateArrowVisibility();
    });

    // Initial arrow visibility check
    updateArrowVisibility();

    // Update on window resize (in case thumbnail size changes)
    var resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        updateArrowVisibility();
        // Re-center selected thumbnail after resize
        autoScrollToSelectedThumbnail();
      }, 250);
    });
    
    // Initialize auto-scroll watcher for selected thumbnails
    watchForImageChanges();
    
    // Initial check: auto-scroll to selected thumbnail on load
    setTimeout(function() {
      autoScrollToSelectedThumbnail();
    }, 500); // Small delay to ensure DOM is fully ready
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(initThumbnailProgressiveDisclosure, 500);
    });
  } else {
    setTimeout(initThumbnailProgressiveDisclosure, 500);
  }

  // Re-initialize on section load (for AJAX navigation)
  document.addEventListener('shopify:section:load', function() {
    setTimeout(initThumbnailProgressiveDisclosure, 500);
  });
})();

/**
 * Initialize mobile carousel overlay arrows
 */
(function() {
  'use strict';

  var isInitialized = false;
  var maxRetries = 10;
  var retryCount = 0;

  function initMobileCarouselArrows() {
    var slideshow = document.querySelector('.Product__Slideshow.Carousel');
    if (!slideshow) {
      if (retryCount < maxRetries) {
        retryCount++;
        setTimeout(initMobileCarouselArrows, 500);
      }
      return;
    }
    
    // Try multiple ways to access Flickity instance
    var flickityInstance = null;
    
    // Method 1: Try Flickity.data() API (recommended method)
    if (window.Flickity && typeof window.Flickity.data === 'function') {
      flickityInstance = window.Flickity.data(slideshow);
    }
    
    // Method 2: Try direct property access
    if (!flickityInstance) {
      flickityInstance = slideshow.Flickity || slideshow.flickity || slideshow.flkty;
    }
    
    // Method 3: Try accessing via jQuery if available
    if (!flickityInstance && window.jQuery) {
      flickityInstance = jQuery(slideshow).data('flickity') || jQuery(slideshow).data('Flickity');
    }
    
    // Method 4: Try accessing via viewport element
    if (!flickityInstance) {
      var viewport = slideshow.querySelector('.flickity-viewport');
      if (viewport) {
        flickityInstance = viewport.Flickity || viewport.flickity;
      }
    }
    
    // If Flickity isn't initialized yet, wait and retry with longer delay
    if (!flickityInstance) {
      if (retryCount < maxRetries) {
        retryCount++;
        setTimeout(initMobileCarouselArrows, 500);
      }
      return;
    }
    
    // Reset retry count on success
    retryCount = 0;
    
    // If already initialized, don't re-initialize
    if (isInitialized) {
      return;
    }
    
    // Get the arrow buttons (they're siblings of slideshow, inside gallery)
    var gallery = slideshow.closest('.Product__Gallery');
    if (!gallery) {
      return;
    }
    
    var prevArrow = gallery.querySelector('.Product__SlideshowOverlayArrow--previous');
    var nextArrow = gallery.querySelector('.Product__SlideshowOverlayArrow--next');
    
    if (!prevArrow || !nextArrow) {
      return;
    }
    
    // Remove existing event listeners by cloning and replacing
    var newPrevArrow = prevArrow.cloneNode(true);
    var newNextArrow = nextArrow.cloneNode(true);
    prevArrow.parentNode.replaceChild(newPrevArrow, prevArrow);
    nextArrow.parentNode.replaceChild(newNextArrow, nextArrow);
    
    // Previous arrow click handler
    newPrevArrow.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (flickityInstance && flickityInstance.previous) {
        flickityInstance.previous();
      }
    });
    
    // Next arrow click handler
    newNextArrow.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (flickityInstance && flickityInstance.next) {
        flickityInstance.next();
      }
    });
    
    isInitialized = true;
  }

  // Initialize with longer delay to ensure Flickity is ready
  function init() {
    setTimeout(function() {
      retryCount = 0;
      initMobileCarouselArrows();
    }, 1000);
  }

  // Initialize on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Also initialize on window load (ensures all scripts are loaded)
  window.addEventListener('load', function() {
    setTimeout(function() {
      retryCount = 0;
      isInitialized = false;
      initMobileCarouselArrows();
    }, 500);
  });

  // Re-initialize on section load (for AJAX navigation and theme editor)
  document.addEventListener('shopify:section:load', function() {
    setTimeout(function() {
      retryCount = 0;
      isInitialized = false;
      initMobileCarouselArrows();
    }, 500);
  });
})();

/**
 * Sticky Add to Cart button on mobile
 * Creates a duplicate button that appears when the real button scrolls out of view
 */
(function() {
  'use strict';

  function initStickyAddToCart() {
    // Declare variables at the top of function scope
    var realButton = null;
    var stickyButton = null;
    var isStickyVisible = false;
    
    // Only on mobile
    if (window.matchMedia('(min-width: 641px)').matches) {
      return;
    }

    var purchaseActions = document.querySelector('.ProductForm__PurchaseActions');
    var addToCartButton = purchaseActions ? purchaseActions.querySelector('.ProductForm__AddToCart:not(.ProductForm__AddToCart--sticky)') : document.querySelector('.ProductForm__AddToCart:not(.ProductForm__AddToCart--sticky)');
    
    if (!addToCartButton || !purchaseActions) {
      return;
    }

    // Assign to function-scope variables so updateStickyButton() can access them
    realButton = addToCartButton;

    // Create card container for sticky button
    var stickyCard = document.createElement('div');
    stickyCard.classList.add('StickyAddToCartCard');
    stickyCard.style.display = 'none'; // Hidden by default
    
    // Create duplicate sticky button (cloneNode(false) to avoid cloning event listeners)
    stickyButton = realButton.cloneNode(false);
    // Manually add the span back so the text sync still works
    stickyButton.innerHTML = '<span>' + realButton.textContent.trim() + '</span>';
    stickyButton.classList.add('ProductForm__AddToCart--sticky');
    
    // Add button to card, then card to body
    stickyCard.appendChild(stickyButton);
    document.body.appendChild(stickyCard);

    // Helper function to attach click handler to sticky button (reusable)
    function attachStickyButtonClickHandler(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Don't proceed if button is disabled
        if (realButton && realButton.disabled) {
          return;
        }
        
        // Find the product form
        var productForm = document.querySelector('form.ProductForm[action*="/cart/add"]');
        if (!productForm) {
          return;
        }
        
        // Disable both buttons
        realButton.setAttribute('disabled', 'disabled');
        button.setAttribute('disabled', 'disabled');
        
        // Show loading state
        document.dispatchEvent(new CustomEvent('theme:loading:start'));
        
        // Serialize form data
        var formData = serializeForm(productForm);
        
        // Submit via AJAX
        fetch((window.routes && window.routes.cartAddUrl ? window.routes.cartAddUrl : '/cart/add') + '.js', {
          body: JSON.stringify(formData),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        }).then(function(response) {
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          
          // Re-enable buttons
          if (realButton) {
            realButton.removeAttribute('disabled');
          }
          if (button) {
            button.removeAttribute('disabled');
          }
          
          return response.json();
        }).then(function(data) {
          // Get variant ID and quantity from form data
          var variantId = formData.id;
          var quantity = parseInt(formData.quantity || 1);
          
          // Try to get full variant object from ProductVariants instance if available
          var variant = { id: variantId };
          var productFormContainer = productForm.closest('[data-section-type="product"]') || productForm.closest('.Product');
          if (productFormContainer) {
            // Check if ProductVariants instance exists and has currentVariant
            var productVariantsData = productFormContainer.ProductVariants || 
                                     (window.theme && window.theme.productVariants) ||
                                     (productFormContainer.querySelector && productFormContainer.querySelector('[data-product-variants]'));
            
            if (productVariantsData && productVariantsData.currentVariant) {
              variant = productVariantsData.currentVariant;
            }
          }
          
          // Dispatch product:added event (this triggers cart drawer update and opening)
          document.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              variant: variant,
              quantity: quantity
            }
          }));
          
          // Also dispatch cart:refresh on documentElement as fallback
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));
        }).catch(function(error) {
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          
          // Re-enable buttons on error
          if (realButton) {
            realButton.removeAttribute('disabled');
          }
          if (button) {
            button.removeAttribute('disabled');
          }
          
          console.error('Error adding to cart:', error);
        });
      });
    }

    // Helper function to serialize form data
    function serializeForm(form) {
      var formData = {};
      var inputs = form.querySelectorAll('input, select, textarea');
      
      for (var i = 0; i < inputs.length; i++) {
        var input = inputs[i];
        if (input.name && !input.disabled) {
          if (input.type === 'checkbox' || input.type === 'radio') {
            if (input.checked) {
              formData[input.name] = input.value;
            }
          } else {
            formData[input.name] = input.value;
          }
        }
      }
      
      return formData;
    }

    // Make sticky button submit the form directly via AJAX
    attachStickyButtonClickHandler(stickyButton);

    // Function to show sticky button with fade in
    function showSticky() {
      if (!isStickyVisible) {
        // Get current variant and update sticky button from variant data
        var productForm = document.querySelector('form.ProductForm[action*="/cart/add"]');
        if (productForm) {
          var productFormContainer = productForm.closest('[data-section-type="product"]') || productForm.closest('.Product');
          if (productFormContainer) {
            // Try to get current variant from ProductVariants instance
            var productVariantsData = productFormContainer.ProductVariants || 
                                     (window.theme && window.theme.productVariants) ||
                                     (productFormContainer.querySelector && productFormContainer.querySelector('[data-product-variants]'));
            
            if (productVariantsData && productVariantsData.currentVariant) {
              updateStickyButtonFromVariant(productVariantsData.currentVariant);
            } else {
              // Fallback: try to get variant from form
              var variantIdInput = productForm.querySelector('input[name="id"]');
              if (variantIdInput && variantIdInput.value) {
                // Try to find variant in product data
                var productData = productFormContainer.querySelector('[data-product-json]');
                if (productData) {
                  try {
                    var product = JSON.parse(productData.textContent);
                    var variant = product.variants.find(function(v) {
                      return v.id.toString() === variantIdInput.value.toString();
                    });
                    if (variant) {
                      updateStickyButtonFromVariant(variant);
                    }
                  } catch (e) {
                    console.error('Error parsing product data:', e);
                  }
                }
              }
            }
          }
        }
        
        // Show card with fade in
        stickyCard.style.display = '';
        stickyCard.style.opacity = '0';
        requestAnimationFrame(function() {
          stickyCard.style.transition = 'opacity 0.3s ease-in-out';
          stickyCard.style.opacity = '1';
        });
        
        isStickyVisible = true;
      }
    }

    // Function to hide sticky button instantly (no fade)
    function hideSticky() {
      if (isStickyVisible) {
        stickyCard.style.transition = 'none';
        stickyCard.style.display = 'none';
        stickyCard.style.opacity = '0';
        isStickyVisible = false;
      }
    }

    // Helper function to attach click handler to sticky button
    function attachStickyButtonClickHandler(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Don't proceed if button is disabled
        if (realButton && realButton.disabled) {
          return;
        }
        
        // Find the product form
        var productForm = document.querySelector('form.ProductForm[action*="/cart/add"]');
        if (!productForm) {
          return;
        }
        
        // Disable both buttons
        realButton.setAttribute('disabled', 'disabled');
        button.setAttribute('disabled', 'disabled');
        
        // Show loading state
        document.dispatchEvent(new CustomEvent('theme:loading:start'));
        
        // Serialize form data
        var formData = serializeForm(productForm);
        
        // Submit via AJAX
        fetch((window.routes && window.routes.cartAddUrl ? window.routes.cartAddUrl : '/cart/add') + '.js', {
          body: JSON.stringify(formData),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        }).then(function(response) {
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          
          // Re-enable buttons
          if (realButton) {
            realButton.removeAttribute('disabled');
          }
          if (button) {
            button.removeAttribute('disabled');
          }
          
          return response.json();
        }).then(function(data) {
          // Get variant ID and quantity from form data
          var variantId = formData.id;
          var quantity = parseInt(formData.quantity || 1);
          
          // Try to get full variant object from ProductVariants instance if available
          var variant = { id: variantId };
          var productFormContainer = productForm.closest('[data-section-type="product"]') || productForm.closest('.Product');
          if (productFormContainer) {
            // Check if ProductVariants instance exists and has currentVariant
            var productVariantsData = productFormContainer.ProductVariants || 
                                     (window.theme && window.theme.productVariants) ||
                                     (productFormContainer.querySelector && productFormContainer.querySelector('[data-product-variants]'));
            
            if (productVariantsData && productVariantsData.currentVariant) {
              variant = productVariantsData.currentVariant;
            }
          }
          
          // Dispatch product:added event (this triggers cart drawer update and opening)
          document.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              variant: variant,
              quantity: quantity
            }
          }));
          
          // Also dispatch cart:refresh on documentElement as fallback
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));
        }).catch(function(error) {
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          
          // Re-enable buttons on error
          if (realButton) {
            realButton.removeAttribute('disabled');
          }
          if (button) {
            button.removeAttribute('disabled');
          }
          
          console.error('Error adding to cart:', error);
        });
      });
    }

    // Update sticky button when real button changes (variant selection, etc.)
    // Always update regardless of visibility so it has correct data when it appears
    function updateStickyButton() {
      // Re-find buttons if references are lost
      if (!realButton) {
        realButton = document.querySelector('.ProductForm__AddToCart:not(.ProductForm__AddToCart--sticky)');
      }
      if (!stickyButton) {
        stickyButton = document.querySelector('.ProductForm__AddToCart--sticky');
      }
      
      if (!realButton || !stickyButton) return;
      
      // Sync text/HTML content
      // We use innerHTML to ensure icons and spans are all preserved
      var stickySpan = stickyButton.querySelector('span');
      var realSpan = realButton.querySelector('span');
      
      if (stickySpan && realSpan) {
        stickySpan.innerHTML = realSpan.innerHTML;
      } else {
        stickyButton.innerHTML = realButton.innerHTML;
      }
      
      // Sync disabled state
      if (realButton.hasAttribute('disabled')) {
        stickyButton.setAttribute('disabled', 'disabled');
        stickyButton.disabled = true;
      } else {
        stickyButton.removeAttribute('disabled');
        stickyButton.disabled = false;
      }
      
      // Sync classes (important for 'is-loading' states)
      stickyButton.className = realButton.className + ' ProductForm__AddToCart--sticky';
    }

    // Helper function to update sticky button from variant data
    function updateStickyButtonFromVariant(variant) {
      if (!variant || !stickyButton) return;

      var stickySpan = stickyButton.querySelector('span');
      var targetElement = stickySpan || stickyButton;

      if (variant.available) {
        targetElement.textContent = 'Add to Bag';
        stickyButton.removeAttribute('disabled');
        stickyButton.disabled = false;
        stickyButton.classList.remove('Button--secondary');
        stickyButton.classList.add('Button--primary');
      } else {
        targetElement.textContent = 'Sold Out';
        stickyButton.setAttribute('disabled', 'disabled');
        stickyButton.disabled = true;
        stickyButton.classList.remove('Button--primary');
        stickyButton.classList.add('Button--secondary');
      }
      
      console.log('Sticky button forced update:', variant.available ? 'Available' : 'Sold Out');
    }

    // Listen for variant changes to update sticky button directly from variant data

    // Function to check if sticky button is 100% on top of real button (perfectly aligned)
    // Used for scroll down behavior
    function isStickyAlignedWithRealButton() {
      var realButtonRect = purchaseActions.getBoundingClientRect();
      var viewportHeight = window.innerHeight;
      
      // Sticky button is positioned at bottom: 20px, so its bottom edge is at viewportHeight - 20px
      var stickyButtonBottomPosition = viewportHeight - 20;
      
      // Get real button height
      var realButtonHeight = realButtonRect.height;
      var realButtonBottom = realButtonRect.bottom;
      var realButtonTop = realButtonRect.top;
      
      // Check if real button's bottom edge aligns with sticky button's bottom position
      // Allow a small tolerance (10px) for smooth transition
      var alignmentTolerance = 10;
      
      // Sticky is aligned when:
      // 1. Real button's bottom edge is at or near the sticky button's bottom position
      // 2. Real button is actually visible (not scrolled past)
      var isBottomAligned = realButtonBottom >= (stickyButtonBottomPosition - alignmentTolerance) && 
                           realButtonBottom <= (stickyButtonBottomPosition + alignmentTolerance);
      
      // Real button is visible if any part is in viewport
      var isRealButtonVisible = realButtonTop < viewportHeight && realButtonBottom > 0;
      
      return isBottomAligned && isRealButtonVisible;
    }

    // Function to check if real button is visible on screen
    // Used for scroll up behavior (previous behavior)
    function isRealButtonVisible() {
      var rect = purchaseActions.getBoundingClientRect();
      var viewportHeight = window.innerHeight;
      // Button is visible if any part of it is within the viewport
      return rect.top < viewportHeight && rect.bottom > 0;
    }

    // Function to check if real button is above viewport (scrolled past going down)
    function isRealButtonAboveViewport() {
      var rect = purchaseActions.getBoundingClientRect();
      // Button is above viewport if its bottom edge is above the viewport top
      return rect.bottom < 0;
    }

    // Intersection Observer to detect when real button is out of view
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) {
          // Real button is out of view - only show sticky if it's above viewport (scrolled past going down)
          if (isRealButtonAboveViewport()) {
            showSticky();
          } else {
            // Real button is below viewport - hide sticky
            hideSticky();
          }
        }
        // Don't hide based on intersection alone - wait for perfect alignment
      });
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 0
    });

    // Observe the purchase actions container
    observer.observe(purchaseActions);

    // Track scroll direction
    var lastScrollY = window.scrollY;
    var scrollDirection = 'down'; // 'up' or 'down'

    // Check on scroll to detect when sticky should hide/show
    var scrollTimeout;
    window.addEventListener('scroll', function() {
      // Determine scroll direction
      var currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY) {
        scrollDirection = 'down';
      } else if (currentScrollY < lastScrollY) {
        scrollDirection = 'up';
      }
      lastScrollY = currentScrollY;

      // Debounce scroll checks
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function() {
        if (isStickyVisible) {
          // Different behavior based on scroll direction
          if (scrollDirection === 'down') {
            // Scroll down: Hide when sticky is 100% aligned with real button
            if (isStickyAlignedWithRealButton()) {
              // Sticky is 100% on top of real button - hide instantly for seamless transition
              hideSticky();
            }
          } else {
            // Scroll up: Hide when real button becomes visible (previous behavior)
            if (isRealButtonVisible()) {
              // Real button is visible - hide sticky instantly
              hideSticky();
            }
          }
        } else {
          // Check if real button is above viewport (scrolled past going down) - show sticky
          if (isRealButtonAboveViewport()) {
            showSticky();
          }
        }
      }, 10); // Small delay to batch scroll events
    }, { passive: true });

    // Initial check - if real button is above viewport on load, show sticky
    if (isRealButtonAboveViewport()) {
      showSticky();
    }

    // Clean up on page unload
    window.addEventListener('beforeunload', function() {
      observer.disconnect();
      if (stickyCard && stickyCard.parentNode) {
        stickyCard.parentNode.removeChild(stickyCard);
      }
    });

    // Add click handler to stickyCard (handles clicks even if button is replaced)
    // Use capture phase to catch the click first and stop any other listeners
    if (stickyCard) {
      stickyCard.addEventListener('click', function(e) {
        var btn = e.target.closest('.ProductForm__AddToCart--sticky');
        if (btn) {
          e.preventDefault();
          e.stopImmediatePropagation(); // Stop any other listeners
          var realBtn = document.querySelector('.ProductForm__AddToCart:not(.ProductForm__AddToCart--sticky)');
          if (realBtn) {
            console.log('Proxy Click: Triggering real button');
            realBtn.click();
          }
        }
      }, true); // Use capture phase to catch the click first
    }

    // Heartbeat Sync: Check every 500ms and force the sticky button to match the real button
    setInterval(function() {
      var realBtn = document.querySelector('.ProductForm__AddToCart:not(.ProductForm__AddToCart--sticky)');
      var stickyBtn = document.querySelector('.ProductForm__AddToCart--sticky');
      
      if (!realBtn || !stickyBtn) return;

      // Sync Text
      var realText = realBtn.textContent.trim();
      var stickySpan = stickyBtn.querySelector('span');
      var target = stickySpan || stickyBtn;
      
      if (target.textContent.trim() !== realText) {
        target.textContent = realText;
        console.log('Heartbeat Sync: Updated text to ' + realText);
      }

      // Sync Disabled State
      if (realBtn.disabled !== stickyBtn.disabled) {
        stickyBtn.disabled = realBtn.disabled;
        if (realBtn.disabled) {
          stickyBtn.setAttribute('disabled', 'disabled');
        } else {
          stickyBtn.removeAttribute('disabled');
        }
      }
    }, 500);
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAddToCart);
  } else {
    initStickyAddToCart();
  }

  // Re-initialize on Shopify section load (for theme editor)
  document.addEventListener('shopify:section:load', function() {
    setTimeout(initStickyAddToCart, 100);
  });
})();

/**
 * Smooth fade transition for product price on variant change
 * Uses MutationObserver to catch the moment the theme clears/updates the price HTML
 */
(function() {
  'use strict';

  var priceList = document.querySelector('.ProductMeta__PriceList');
  if (priceList) {
    var priceObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          // Target only the price elements, not the whole container
          var prices = priceList.querySelectorAll('.ProductMeta__Price');
          
          prices.forEach(function(price) {
            price.style.transition = 'none';
            price.style.opacity = '0';
            
            setTimeout(function() {
              price.style.transition = 'opacity 0.3s ease-in-out';
              price.style.opacity = '1';
            }, 50);
          });
        }
      });
    });

    priceObserver.observe(priceList, { childList: true });
  }
})();

/**
 * Cart Drawer & Cart Page - Gift Message Handler
 * Note: Sticky footer is handled via CSS position: sticky
 */
(function() {
  'use strict';

  var saveTimeout = null;
  var lastSavedMessage = null;
  var isFlushingOnSubmit = false;

  function isGiftMessageTextarea(el) {
    if (!el || el.tagName !== 'TEXTAREA') return false;
    return el.id === 'cart-drawer-gift-message' || el.id === 'cart-page-gift-message';
  }

  function saveGiftMessage(message) {
    if (!window.routes || !window.routes.cartUrl) return Promise.resolve();

    var formData = {
      note: message,
      // Migration: clear the old cart attribute so it stops appearing under "Additional details"
      attributes: { 'Gift Message': '' }
    };

    return fetch(window.routes.cartUrl + '/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(formData)
    }).then(function() {
      lastSavedMessage = message;
    }).catch(function(error) {
      console.error('Error saving gift message:', error);
    });
  }

  // Save gift message to cart note (order notes) using event delegation
  function setupGiftMessage() {
    if (!window.routes || !window.routes.cartUrl) return;

    // Save while typing (debounced) so checkout doesn't race the save
    document.addEventListener('input', function(event) {
      var giftMessageInput = event.target;
      if (!isGiftMessageTextarea(giftMessageInput)) return;

      clearTimeout(saveTimeout);
      saveTimeout = setTimeout(function() {
        saveGiftMessage(giftMessageInput.value.trim());
      }, 300);
    }, true);

    // Also save on blur as a backstop
    document.addEventListener('blur', function(event) {
      var giftMessageInput = event.target;
      if (!isGiftMessageTextarea(giftMessageInput)) return;

      clearTimeout(saveTimeout);
      saveGiftMessage(giftMessageInput.value.trim());
    }, true); // Use capture phase for event delegation

    // Ensure we flush the latest message before checkout submit happens
    document.addEventListener('submit', function(event) {
      if (isFlushingOnSubmit) return;
      if (!event || !event.target) return;

      var form = event.target;
      if (!form || form.nodeName !== 'FORM') return;

      var giftMessageInput = form.querySelector('#cart-drawer-gift-message, #cart-page-gift-message');
      if (!giftMessageInput) return;

      var message = giftMessageInput.value.trim();
      if (message === (lastSavedMessage || '')) return;

      event.preventDefault();
      event.stopPropagation();
      clearTimeout(saveTimeout);

      saveGiftMessage(message).finally(function() {
        // Re-trigger the original submit button click (keeps name="checkout" behaviour).
        isFlushingOnSubmit = true;
        var submitter = event.submitter;
        if (submitter && typeof submitter.click === 'function') {
          submitter.click();
        } else if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }

        // Safety: if the page doesn't navigate (edge cases), allow future submits.
        setTimeout(function() { isFlushingOnSubmit = false; }, 1500);
      });
    }, true);
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupGiftMessage);
  } else {
    setupGiftMessage();
  }
})();

/**
 * Cart Drawer & Cart Page - Gift Message Toggle (Accordion)
 * Using event delegation to handle AJAX cart updates
 */
(function() {
  'use strict';

  function handleGiftToggleClick(e) {
    var giftToggle = e.target.closest('.cart-drawer__gift-toggle');
    if (!giftToggle) return;

    e.preventDefault();
    e.stopPropagation();
    
    var contentId = giftToggle.getAttribute('aria-controls');
    if (!contentId) return;

    var content = document.getElementById(contentId);
    if (!content) return;

    var isExpanded = giftToggle.getAttribute('aria-expanded') === 'true';
    
    giftToggle.setAttribute('aria-expanded', !isExpanded);
    content.setAttribute('aria-hidden', isExpanded);
    
    // Auto-focus textarea when expanded
    if (!isExpanded) {
      setTimeout(function() {
        var textarea = content.querySelector('textarea');
        if (textarea) textarea.focus();
      }, 150);
    }
  }

  // Use event delegation on the cart drawer container
  function setupGiftMessageToggle() {
    var cartDrawer = document.getElementById('sidebar-cart');
    if (cartDrawer) {
      // Remove old listener if exists, then add new one
      cartDrawer.removeEventListener('click', handleGiftToggleClick);
      cartDrawer.addEventListener('click', handleGiftToggleClick);
    }

    // Also handle cart page
    var cartPage = document.querySelector('.cart-page-form, .Cart--expanded');
    if (cartPage) {
      cartPage.removeEventListener('click', handleGiftToggleClick);
      cartPage.addEventListener('click', handleGiftToggleClick);
    }

    // Auto-expand if message already exists
    var giftToggles = document.querySelectorAll('.cart-drawer__gift-toggle');
    giftToggles.forEach(function(giftToggle) {
      var contentId = giftToggle.getAttribute('aria-controls');
      if (!contentId) return;
      var content = document.getElementById(contentId);
      if (!content) return;
      var textarea = content.querySelector('textarea');
      if (textarea && textarea.value.trim()) {
        giftToggle.setAttribute('aria-expanded', 'true');
        content.setAttribute('aria-hidden', 'false');
      }
    });
  }

  // Use document-level event delegation as a fallback for cart page
  // This ensures it works even if setupGiftMessageToggle hasn't run yet
  // or when navigating to cart page after adding an item
  document.addEventListener('click', function(e) {
    // Only handle if it's a gift toggle button
    var giftToggle = e.target.closest('.cart-drawer__gift-toggle');
    if (!giftToggle) return;
    
    // Check if we're on the cart page
    var isCartPage = document.querySelector('.cart-page-form, .Cart--expanded');
    if (!isCartPage) return;
    
    // Only handle if the click is within the cart page form
    var cartPageForm = giftToggle.closest('.cart-page-form, .Cart--expanded');
    if (!cartPageForm) return;
    
    // Call the handler
    handleGiftToggleClick(e);
  }, true); // Use capture phase to ensure we catch it early

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupGiftMessageToggle);
  } else {
    setupGiftMessageToggle();
  }

  // Re-initialize when cart drawer opens or refreshes
  document.addEventListener('cart:refresh', function() {
    setTimeout(setupGiftMessageToggle, 100);
  });
  
  // Also listen for drawer open events
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
        var drawer = document.getElementById('sidebar-cart');
        if (drawer && drawer.getAttribute('aria-hidden') === 'false') {
          setTimeout(setupGiftMessageToggle, 100);
        }
      }
    });
  });

  var drawer = document.getElementById('sidebar-cart');
  if (drawer) {
    observer.observe(drawer, { attributes: true });
  }

  // Watch for cart page form appearing (for AJAX navigation or dynamic loading)
  var cartPageObserver = new MutationObserver(function(mutations) {
    var cartPageForm = document.querySelector('.cart-page-form, .Cart--expanded');
    if (cartPageForm) {
      setupGiftMessageToggle();
    }
  });

  // Observe the main content area for cart page
  var mainContent = document.querySelector('main, .PageContainer, body');
  if (mainContent) {
    cartPageObserver.observe(mainContent, {
      childList: true,
      subtree: true
    });
  }

  // Also initialize for cart page on load with multiple attempts
  if (document.querySelector('.cart-page-form')) {
    setTimeout(setupGiftMessageToggle, 100);
    setTimeout(setupGiftMessageToggle, 500);
    setTimeout(setupGiftMessageToggle, 1000);
  }

  // Re-initialize when page becomes visible (handles navigation to cart page)
  document.addEventListener('visibilitychange', function() {
    if (!document.hidden && document.querySelector('.cart-page-form')) {
      setTimeout(setupGiftMessageToggle, 100);
    }
  });

  // Also listen for popstate (browser back/forward) and pageshow events
  window.addEventListener('pageshow', function() {
    if (document.querySelector('.cart-page-form')) {
      setTimeout(setupGiftMessageToggle, 100);
    }
  });
})();